// src/pages/emailMarketing/ContactsRFMPage.jsx
import React, { useState, useEffect } from 'react';
import { get } from '../../helpers/apiHelper';
import useAuthStore from '../../store/authStore';
import emailMarketingService from '../../helpers/emailMarketingService';

function ContactsRFMPage() {
    const { user } = useAuthStore();
    const [marcas, setMarcas] = useState([]);
    const [selectedMarca, setSelectedMarca] = useState(null);
    const [rfmData, setRfmData] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchMarcas();
    }, [user]);

    useEffect(() => {
        if (selectedMarca) {
            fetchRFMData();
        }
    }, [selectedMarca]);

    const fetchMarcas = async () => {
        try {
            if (user?.userId) {
                const response = await get(`marcas/user/${user.userId}`);
                setMarcas(response);
                if (response.length > 0) {
                    setSelectedMarca(response[0]._id);
                }
            }
        } catch (error) {
            // Error silencioso
        }
    };

    const fetchRFMData = async () => {
        setLoading(true);
        try {
            const data = await emailMarketingService.getRFMAnalysis(selectedMarca);
            setRfmData(data);
        } catch (error) {
            // Error silencioso
        } finally {
            setLoading(false);
        }
    };

    if (loading) {
        return (
            <div className="container mx-auto px-4 py-6">
                <div className="text-center">Cargando...</div>
            </div>
        );
    }

    return (
        <div className="container mx-auto px-4 py-6">
            <div className="flex justify-between items-center mb-6">
                <h1 className="text-3xl font-bold">Análisis RFM de Contactos</h1>
                {marcas.length > 0 && (
                    <select
                        value={selectedMarca || ''}
                        onChange={(e) => setSelectedMarca(e.target.value)}
                        className="px-4 py-2 border border-gray-300 rounded"
                    >
                        {marcas.map(marca => (
                            <option key={marca._id} value={marca._id}>
                                {marca.nombre}
                            </option>
                        ))}
                    </select>
                )}
            </div>

            {rfmData && rfmData.segments ? (
                <div className="bg-white rounded-lg shadow overflow-hidden">
                    <table className="min-w-full divide-y divide-gray-200">
                        <thead className="bg-gray-50">
                            <tr>
                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Segmento</th>
                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Total Contactos</th>
                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Porcentaje</th>
                            </tr>
                        </thead>
                        <tbody className="bg-white divide-y divide-gray-200">
                            {Object.entries(rfmData.segments).map(([segment, count]) => {
                                const total = Object.values(rfmData.segments).reduce((sum, val) => sum + val, 0);
                                const percentage = total > 0 ? ((count / total) * 100).toFixed(1) : 0;
                                return (
                                    <tr key={segment} className="hover:bg-gray-50">
                                        <td className="px-6 py-4 whitespace-nowrap">
                                            <div className="text-sm font-medium text-gray-900">{segment}</div>
                                        </td>
                                        <td className="px-6 py-4 whitespace-nowrap">
                                            <div className="text-sm text-gray-900">{count}</div>
                                        </td>
                                        <td className="px-6 py-4 whitespace-nowrap">
                                            <div className="text-sm text-gray-900">{percentage}%</div>
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            ) : (
                <div className="bg-white p-8 rounded-lg shadow text-center text-gray-500">
                    No hay datos de segmentación RFM disponibles.
                </div>
            )}
        </div>
    );
}

export default ContactsRFMPage;

